import {API_URL, MOKA_SERVICE_URL} from 'api/constants'

export const CUSTOMERS = `${MOKA_SERVICE_URL}/customer/v1/customers`
export function CUSTOMER_DETAIL (customerId) { return (`${MOKA_SERVICE_URL}/customer/v1/customers/${customerId}`) }
export const CUSTOMERS_DOWNLOAD_TEMPLATE = `${API_URL}/v1/customers/import_customers_template`
export const CUSTOMERS_EXPORT = `${MOKA_SERVICE_URL}/customer/v1/customers/export`
export const CUSTOMERS_SUBMIT_FEEDBACK = `${API_URL}/v1/customers/submit_feedback`
export const REDEMPTION_HISTORIES = (customerId) => `${MOKA_SERVICE_URL}/loyalty/v1/customers/${customerId}/redemptions`
export const POINT_ACTIVITIES = (customerId) => `${MOKA_SERVICE_URL}/loyalty/v1/customers/${customerId}/point-activities`



// WEBPACK FOOTER //
// ./app/api/customers/constants.js